import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import Table from "../../../ui-components/table/table";
import ProbillPreview from "../../common/probill-preview/probillPreview";
import XGSNavLink from "../../../ui-components/xgs-nav-link/xgsNavLink";
import MetricCard from "./MetricCard";
import { CustomerServiceCall, CustomerServiceAnalysis } from "../../../app/data/terminal-insights/models";
import { getIssueTypeIcon, getIssueTypeColor, formatLabelSentenceCase } from "../utils/customerServiceUtils";

interface CustomerServiceDetailsProps {
  data: {
    summary: CustomerServiceAnalysis;
    description: string[];
  };
}

const customerServiceColumnHelper = createColumnHelper<CustomerServiceCall>();

const CustomerServiceDetails: React.FC<CustomerServiceDetailsProps> = ({ data }) => {
  // Customer Service table columns
  const customerServiceColumns = [
    customerServiceColumnHelper.accessor("probill", {
      id: "probill",
      header: "Probill",
      cell: (cellProps) => (
        <ProbillPreview probillNumber={Number(cellProps.getValue())}>
          <span>
            <XGSNavLink
              className="xgs-table-link-cell"
              to={`/shipments/${cellProps.getValue()}`}
              target="__blank"
            >
              {cellProps.getValue()}
            </XGSNavLink>
          </span>
        </ProbillPreview>
      ),
      size: 90
    }),
    customerServiceColumnHelper.accessor("call_date", {
      id: "call_date",
      header: "Date",
      cell: (cellProps) => moment(cellProps.getValue()).format('MMM DD'),
      size: 65
    }),
    customerServiceColumnHelper.accessor("call_time", {
      id: "call_time",
      header: "Time",
      size: 55
    }),
    customerServiceColumnHelper.accessor("category", {
      id: "category",
      header: "Category",
      cell: (cellProps) => (
        <span className="category-badge">
          {cellProps.getValue() === 'Phone Call' ? '📞' : '💬'} &nbsp; {cellProps.getValue().replace(' Call', '').replace('Web ', '')}
        </span>
      ),
      size: 85
    }),
    customerServiceColumnHelper.accessor("types", {
      id: "types",
      header: "Issue Type",
      size: 140
    }),
    // customerServiceColumnHelper.accessor("outcome", {
    //   id: "outcome",
    //   header: "Result",
    //   cell: (cellProps) => (
    //     <span className={`customer-service__outcome ${cellProps.getValue().toLowerCase()}`}>
    //       {cellProps.getValue() === 'Satisfactory' ? '✅' : '❌'} {cellProps.getValue().substring(0, 6)}
    //     </span>
    //   ),
    //   size: 75
    // })
  ];

  return (
    <div className="customer-service-details">
      <div className="customer-service-details__metric-cards">
        {Object.entries(data.summary.types_breakdown).map(([type, count]) => (
          <MetricCard
            key={type}
            icon={getIssueTypeIcon(type)}
            title={formatLabelSentenceCase(type)}
            value={Number(count)}
            subtitle="Calls"
            color={getIssueTypeColor(type, type === data.summary.top_issue_type)}
          />
        ))}
      </div>
      <div className="customer-service-details__table">
        <Table
          sorting
          columns={customerServiceColumns}
          data={data.summary.calls}
          responsive
          enableRowSelection={false}
          noResultsText="No customer service calls available"
          infiniteScroll
          minTableHeight={320}
          maxTableWidth={1110}
        />
      </div>
    </div>
  );
};

export default CustomerServiceDetails;
